import { useQuery } from '@tanstack/react-query'
import type { ChannelType, ChannelTypeKey } from '@/shared/api'
import { channelCatalogQuery } from '../api/queries'

/** Тип канала из каталога: способ подключения, шаги, право на имя. Пока каталог не пришёл — нет. */
export function useChannelKind(type: ChannelTypeKey): ChannelType | undefined {
  const catalog = useQuery(channelCatalogQuery())
  return catalog.data?.find((kind) => kind.type === type)
}
